<template>
  <div class="mobile-container">
    <v-alert
      dense
      text
      color="var(--logistic)"
      class="caption-regular high-emp pa-3 my-3"
      rounded="0"
      >
      <template v-slot:prepend>
        <svg-icon
          width="44"
          height="44"
          color="var(--logistic)"
          name="guide"
          class="ml-1 mb-auto"
        ></svg-icon>
      </template>
      برای جابه جا کردن ترتیب‌ بارگیری، انگشت خود را روی محل بارگیری مورد نظر
      نگه دارید و آن را به موقعیت دلخواه انتقال دهید</v-alert
    >
    <draggable v-model="senderRecieverList">
      <transition-group>
        <div
          v-for="(sr, i) of senderRecieverList"
          :key="i + 999"
          class="pb-05 mb-2"
        >
          <v-card class="ev-2 row mx-0 pa-3 pr-4 cursor-move" rounded="0">
            <span class="high-emp subtitle2-medium"
              >{{ place }} {{ i + 1 }}</span
            >
            <span
              class="body2-light medium-emp pr-2"
              v-text="sr.address"
            ></span>
            <v-spacer></v-spacer>
            <svg-icon name="arrow-up-down"></svg-icon>
          </v-card>
        </div>
      </transition-group>
    </draggable>
    <v-card-actions class="w-100 position-fixed bottom-0 px-4">
      <v-col cols="12" class="pa-0 mobile-container">
        <v-btn @click="save()" block class="logistic-color white--text py-6"
          >ثبت تغییرات</v-btn
        >
      </v-col>
    </v-card-actions>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "Reorder",
  components: {
    draggable,
  },
  props: {
    list: {
      require: true,
      type: Array,
    },
    place: String,
  },
  watch: {
    list: {
      handler(value) {
        this.senderRecieverList = value;
      },
      immediate: true,
    },
  },
  data() {
    return {
      senderRecieverList: null,
    };
  },
  methods: {
    save() {
      let list = this.senderRecieverList;
      let START_ORDER_ID = this.type == "receiver" ? 20 : 10;

      list.map((item) => {
        item.order_id = START_ORDER_ID++;
      });

      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.cursor-move {
  cursor: move;
}
</style>
